import { ConnectionItem, Flex, Image, Link, Text } from "@wayflyer/flyui";
import { useState, type ReactNode } from "react";
import { useIntl } from "react-intl";
import { connectByPath } from "../../../data-sources";
import { useCustomerAppConfig } from "undercarriage";

import { usePlatformConnectorProperties } from "../../queries";
import { authStartPath, useConnectionFlowsConfig } from "../../config";
import { COMMON_MESSAGES } from "../../common-messages";
import { ConnectionsList } from "../../common/connections";
import { OAuthErrorBanner } from "../../common/oauth-error-banner";
import { MESSAGES } from "../../messages";

const CONNECTOR_SLUG = "stripe2";

export const StripeConnect = ({ onInitiateConnection }: { onInitiateConnection?: () => void }) => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();
  const { connectorsApiUrl, defaultCallbackPath } = useConnectionFlowsConfig();
  const { data: connectorProperties } = usePlatformConnectorProperties(
    customerDomain,
    CONNECTOR_SLUG,
    defaultCallbackPath,
    connectorsApiUrl
  );
  const [connectionInProgress, setConnectionInProgress] = useState(false);

  return (
    <Flex direction="column" gap="8">
      <Flex direction="column" gap="8" align="flex-start" justify="space-between">
        <OAuthErrorBanner connectorSlug={CONNECTOR_SLUG} />
        <Text>{intl.formatMessage(MESSAGES.paymentPlatformDataUsage)}</Text>
        <ConnectionsList
          connectorProperties={connectorProperties}
          renderConnectAnother={(onConnectAnother) => (
            <Text size="sm">
              {intl.formatMessage(MESSAGES.connectAnotherAccount, {
                link: (chunks: ReactNode) => <Link onClick={onConnectAnother}>{chunks}</Link>,
              })}
            </Text>
          )}
          connectForm={
            <ConnectionItem
              logo={
                connectorProperties.connectionLogoSrc ? <Image src={connectorProperties.connectionLogoSrc} /> : null
              }
              label={connectorProperties.name}
              loading={connectionInProgress}
              actions={[
                {
                  content: intl.formatMessage(COMMON_MESSAGES.connectAccount),
                  variant: "Tertiary",
                  onAction: () => {
                    onInitiateConnection?.();
                    setConnectionInProgress(true);
                    connectByPath(authStartPath(customerDomain, CONNECTOR_SLUG, defaultCallbackPath));
                  },
                },
              ]}
            />
          }
        />
      </Flex>
    </Flex>
  );
};
